import {combineReducers, Reducer} from 'redux';
import {IState as IContainerState, reducer as container} from '../core/Container/reducer';
import {IState as ITriggerState, reducer as trigger} from '../core/Trigger/reducers';
import {IState as IFormState, reducer as form} from '../core/Form/reducers';

export interface RootState {
    container: IContainerState;
    trigger: ITriggerState;
    form: IFormState;
}

export const rootReducer: Reducer<RootState> = combineReducers<RootState>({
    container,
    trigger,
    form
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/render/data/reducers.ts